import React from 'react';

import { DangerText } from '../ContractText';

const PayUnbeatableFee = () => {
  return (
    <span>
      Seller to credit $1,000 of purchase price to buyer at closing, covering
      first the Unbeatable Loans LLC fee. Should this fee or any portion be
      waived at the discretion of Unbeatable Loans LLC, seller credit of $1,000
      will be applied to closing costs, down payments, inspection fees, and
      other associated costs.
    </span>
  );
};

export default PayUnbeatableFee;
